import { useCollectPaymentMultiContext } from '../../collect-payment-multi.context';

export type ProcessorSwitchProps = React.PropsWithChildren<{
  stripeContent?: (props: React.PropsWithChildren<object>) => React.ReactNode;
  justifiContent?: (props: React.PropsWithChildren<object>) => React.ReactNode;
}>;
export const ProcessorSwitch = ({
  children,
  stripeContent: StripeContent,
  justifiContent: JustifiContent,
}: ProcessorSwitchProps) => {
  const { activeGateway } = useCollectPaymentMultiContext();

  return (
    <>
      {/* In the future we will probably want to add care credit here. */}
      {/* As of now, care credit checks are nested inside of the Stripe checks. */}
      {/* A better architecture would be to have CC and stripe not be dependeng on one another */}
      {activeGateway === 'stripe' && typeof StripeContent === 'function' && <StripeContent>{children}</StripeContent>}
      {activeGateway === 'justifi' && typeof JustifiContent === 'function' && (
        <JustifiContent>{children}</JustifiContent>
      )}
    </>
  );
};
